import React from "react";

/**
 * Cabeçalho de agrupamento exibido acima de cada tabela de grupo.
 * Mostra o nome do cliente/fornecedor/data e opcionalmente dados de pagamento.
 */
export default function GrupoHeader({ nome, dadosPagamento, isEnglish = false }) {
  return (
    <>
      <div className="grupo-header">
        {nome}
      </div>
      {dadosPagamento && (
        <div className="grupo-dados-pagamento">
          {isEnglish ? "PAYMENT DETAILS:" : "DADOS PARA PAGAMENTO:"} {dadosPagamento.tipo?.toUpperCase() || "BOLETO"}
          {dadosPagamento.info && ` ${dadosPagamento.info}`}
          {dadosPagamento.tipo === "PIX" && dadosPagamento.cnpj && ` (CNPJ): ${dadosPagamento.cnpj}`}
        </div>
      )}
    </>
  );
}